module.exports = __webpack_public_path__ + "static/media/celery.5808f958.png";